import React, { useState, useEffect } from "react";
import "./Section2.css";

const images = [
  {
    src: "/Section2_Image1_Figma.jpg",
    title: "Building Legacies",
    body:
      "With over six decades of excellence, we have been a cornerstone in shaping modern Libya, combining innovation with a deep respect for tradition.",
  },
  {
    src: "/Section2_Image2_Figma.jpg",
    title: "A Vision for Tomorrow",
    body:
      "Guided by a forward-thinking vision, we continue to redefine the engineering landscape.",
  },
  {
    src: "/Section2_Image3_Figma.jpg",
    title: "Architecting the Future",
    body:
      "Our architectural expertise merges creativity with functionality.",
  },
];

export default function Section2() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const current = images[currentIndex];

  return (
    <div className="section2">

      <div className="section2-header">
        <h2>Explore Our Site</h2>
        <div className="section2-arrow">↓</div>
      </div>

      <div className="section2-main">

        {/* LEFT */}
        <div className="section2-text-box-container">

          <div className="section2-text-box">
            <h3>{current.title}</h3>
            <p>{current.body}</p>
          </div>

          <div className="section2-below-box">
            <p className="section2-text">
              You can learn more about our company’s history here
            </p>

            <button className="section2-learn-more">
              Learn More
            </button>
          </div>

        </div>

        {/* RIGHT */}
        <div className="section2-carousel">
          <img
            src={current.src}
            alt={current.title}
            className="section2-carousel-image"
          />
        </div>

      </div>
    </div>
  );
}